import React from 'react'

export default function PdfOcr(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100">
        <g class="pdfOcr 1">
          <path
            fill="#FDE5E5"
            stroke="#EC2227"
            stroke-miterlimit="10"
            d="M24.2 91.2c-2.5 0-4.6-1.9-4.6-4.2L19 13.2c0-1.1.4-2.1 1.3-2.9.8-.8 2-1.2 3.1-1.2L62 8.9c1.2 0 2.3.4 3.1 1.2L79 23l.4.4c.7.6 1 1.4 1 2.2l.6 61c0 1.2-.5 2.2-1.3 3.1-.9.8-2.1 1.3-3.3 1.3l-52.2.2Z"
            class="Vector"
          />
          <path
            stroke="#999"
            stroke-miterlimit="10"
            stroke-width=".25"
            d="m97.6 75 .1.1"
            class="Vector"
          />
          <g class="Group">
            <path
              fill="#FDE5E5"
              d="M73 63.5H27c-.6 0-1-.4-1-1v-25c0-.6.4-1 1-1h46c.6 0 1 .4 1 1v25.1c0 .5-.5.9-1 .9Z"
              class="Vector"
            />
            <path
              stroke="#EC2227"
              stroke-dasharray="2 2"
              stroke-miterlimit="10"
              stroke-width=".5"
              d="M73 63.5H27c-.6 0-1-.4-1-1v-25c0-.6.4-1 1-1h46c.6 0 1 .4 1 1v25.1c0 .5-.5.9-1 .9Z"
              class="Vector"
            />
          </g>
          <path
            fill="#ED1C24"
            d="M70.6 61.8H29.4c-1 0-1.8-.8-1.8-1.8V40.1c0-1 .8-1.8 1.8-1.8h41.2c1 0 1.8.8 1.8 1.8V60c0 1-.8 1.8-1.8 1.8Z"
            class="Vector"
            opacity=".15"
          />
          <g class="Group">
            <path
              fill="#C1272D"
              d="M37.2 49.6c0-.9.1-1.6.4-2.2.2-.4.5-.8.8-1.2.3-.4.7-.6 1.1-.8.5-.2 1.2-.3 1.9-.3 1.3 0 2.3.4 3 1.2.7.8 1.1 1.9 1.1 3.3s-.4 2.5-1.1 3.3c-.7.8-1.8 1.2-3 1.2-1.3 0-2.3-.4-3-1.2-.7-.8-1.2-1.9-1.2-3.3Zm1.8 0c0 1 .2 1.7.7 2.2.5.5 1 .8 1.7.8s1.3-.2 1.7-.7c.4-.5.7-1.2.7-2.2 0-1-.2-1.7-.6-2.2-.4-.5-1-.7-1.7-.7s-1.3.2-1.7.7c-.4.5-.8 1.1-.8 2.1Zm13.4 1.1 1.7.5c-.3.9-.7 1.6-1.3 2.1-.6.5-1.4.7-2.3.7-1.1 0-2.1-.4-2.8-1.2-.7-.8-1.1-1.8-1.1-3.2 0-1.4.4-2.5 1.1-3.3.7-.8 1.7-1.2 2.9-1.2 1.1 0 1.9.3 2.6.9.4.4.7.9.9 1.6l-1.7.4c-.1-.4-.3-.8-.6-1.1-.3-.3-.7-.4-1.2-.4-.6 0-1.2.2-1.5.7-.3.5-.6 1.2-.6 2.2 0 1.1.2 1.9.6 2.3.4.4.9.7 1.5.7.5 0 .9-.1 1.2-.4.3-.3.4-.6.6-1.3Zm3.1 3.2v-8.6h3.7c.9 0 1.6.1 2 .2.4.1.7.4 1 .8.3.4.4.8.4 1.4 0 .6-.2 1.2-.6 1.6-.4.4-.9.7-1.7.8.4.2.7.5.9.7.2.2.6.7 1 1.4l1 1.7h-2.1L59.9 52c-.4-.7-.8-1.1-.9-1.3-.1-.2-.3-.3-.5-.4-.2-.1-.5-.1-.9-.1h-.4v3.6h-1.7v.1Zm1.8-5h1.3c.8 0 1.4 0 1.6-.1.2-.1.4-.2.5-.4.1-.2.2-.4.2-.6 0-.3-.1-.5-.2-.7-.1-.2-.4-.3-.7-.3h-2.7v2.1Z"
              class="Vector"
            />
          </g>
          <path
            fill="#FDE5E5"
            d="M70 64.7a4.9 4.9 0 1 0 0-9.8 4.9 4.9 0 0 0 0 9.8Z"
            class="Vector"
          />
          <g class="Group">
            <g class="Group">
              <path
                fill="#C1272D"
                d="M65.8 59.8c0 2.3 1.9 4.2 4.2 4.2.9 0 1.8-.3 2.5-.8l.3.5 1.1-1.1-.5-.3c.5-.7.8-1.6.8-2.5 0-2.3-1.9-4.2-4.2-4.2-2.3 0-4.2 1.9-4.2 4.2Zm.8 0c0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4-1.5 3.4-3.4 3.4c-1.8 0-3.4-1.5-3.4-3.4Zm10.5 6c.2.2.2.5 0 .7l-.4.4c-.2.2-.5.2-.7 0L73.2 64l1.1-1.1 2.8 2.9Z"
                class="Vector"
              />
              <path
                fill="#C1272D"
                d="M70 56.8c.7 0 1.4.3 1.9.7.5.5.9 1.1 1 1.8 0 .1-.1.3-.2.3s-.2-.1-.3-.2c-.1-.6-.4-1.1-.8-1.4-.4-.4-1-.6-1.6-.6-.1 0-.3-.1-.3-.3.1-.1.2-.3.3-.3Z"
                class="Vector"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}
